import MonitoringServiceOrderConfirmReceptModal from './monitoring-service-order-confirm-recept-modal.vue'
export default MonitoringServiceOrderConfirmReceptModal
